import { type AccountInfo } from '@/services/types/mockAccountInfo'
import { type AccountSettingsType } from '@/services/types/mockAccountSettings'
import { api, v2BaseURL } from './api'
import { endpoints } from './endpoints'

export const accountService = {
  async getAccountSettings(id: string) {
    return api.get<AccountSettingsType>(`${endpoints.accountSettings}/${id}`)
  },

  async updateAccountSettings(id: string, data: AccountSettingsType) {
    return api.patch<AccountSettingsType>(`${endpoints.accountSettings}/${id}`, data)
  },

  async getAccountInfo(id: string) {
    return api.get<AccountInfo>(endpoints.accounts.replace(':id', id), {
      baseURL: v2BaseURL,
    })
  },
}
